import ClientsDataRegisterCommands from './components/hmilib/hmiclientsdata';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppKP from './AppKP';
import '@ixyberfree/ixybercomponents/dist/esm/index.css';
import { rootStore, useStores } from 'store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<AppKP />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ClientsDataRegisterCommands();

async function initializeApp() {
    await rootStore.AuthStore.checkAuth();

    const loading = rootStore.AuthStore.isLoading;

    if (!loading) {
        ClientsDataRegisterCommands();
    }
    

    const cookies = document.cookie.split('; ');
    const userCookieExists = cookies.some(cookie => cookie.startsWith('user='));
    const rolesCookieExists = cookies.some(cookie => cookie.startsWith('roles='));

    if(!userCookieExists && !rolesCookieExists) {
        document.cookie = 'user=;roles=;page=;path=/';
    }
}

initializeApp().catch((error) => {
    console.error('Failed to initialize the app:', error);
});
